<template>
    <div class="dw-badge">
        <slot></slot>
    </div>
</template>

<style lang="scss">
.dw-badge {
    font-size: 12px;
    border-radius: 6px;
    padding: 4px 8px;
    
    text-align: center;
    white-space: nowrap;

    &.dw-badge--blue {
        background-color: #2C53F5;
        color: white;
    }

    &.dw-badge--orange {
        background-color: #F08B47;
        color: white;
    }

    &.dw-badge--red {
        background-color: #FF3535;
        color: white;
    }

    &.dw-badge--red-light {
        background-color: #FE6B6B;
        color: white;
    }
}
</style>